<app-student-related-events *ngIf="showStudentRelatedEventsDialog$ | async" [stdentDetails]="stdentDetails"
  [isEI]="isEI" [studentSk$]="studentSk" (closeDialog)="closeStudentRelatedEventsDialog()">
</app-student-related-events>

<div>
  <app-dashboard [title]="gridTitle" [columnDefinitions]="columnDefinitions" [gridApiRoute]="gridApiRoute"
    [studentSk]="studentSk" [initialGridState]="initialGridState" [refershGrid]="refershGrid" [studentDetails]="stdentDetails"
    [addButtonText]="addButtonText"  [gridHeader]="gridHeader" [permissionToView]="4" (addToGrid)="openStudentRelatedEventsDialog()">
  </app-dashboard>
</div>